import React, { useEffect } from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeDrawerErrors, autoEuropeSeasonSetsMap } from "Pages/AutoEuropeTool/Page/@signals"

const toOption = ({ id, name }) => ({ value: id, label: name })

export default function AutoEuropeSeasonSetField() {
	const initial = autoEuropeDrawerData.peek().seasonSetId ?? null
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(initial)

	const isValid = !!dataInfo.value

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, seasonSetId: isValid }
	}, [isValid])

	return <AutocompleteAjaxSeeker
		label="Season Set"
		placeholder="Select a season set"
		urlAjax={`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets/list`}
		onAjax={options => {
			const mapped = options.map(toOption)
			autoEuropeSeasonSetsMap.value = Object.fromEntries(mapped.map(o => [o.value, o.label]))
			return mapped
		}}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, "seasonSetId")}
		error={!isValid ? "Season set is required" : undefined}
	/>
}
